'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _extends = require('./extends-214be52a.js');

var defineProperty = require('./defineProperty-754b29ce.js');

var React = require('react');

var getDisplayName = require('./getDisplayName-fd5924a6.js');

var environment = require('./environment.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var observe = function observe(_observe) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _class;

    return _class = /*#__PURE__*/function (_React__default$defau) {
      _inherits(_class, _React__default$defau);

      var _super = _createSuper(_class);

      function _class() {
        var _this;

        _classCallCheck(this, _class);

        _this = _super.apply(this, arguments);

        defineProperty._defineProperty(_assertThisInitialized(_this), "state", initialState);

        defineProperty._defineProperty(_assertThisInitialized(_this), "subscribe", function (observable) {
          if (observable) {
            _this.setState({
              subscription: _observe(observable).subscribe(function (state) {
                _this.setState(state);
              })
            });
          }
        });

        defineProperty._defineProperty(_assertThisInitialized(_this), "unsubscribe", function () {
          _this.state.subscription && _this.state.subscription.unsubscribe();
        });

        return _this;
      }

      _createClass(_class, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.subscribe(this.props.observable);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(_ref) {
          var nextObservable = _ref.observable;
          var observable = this.props.observable; // If a new observable gets passed in, unsubscribe from the old and subscribe to the new

          if (nextObservable !== observable) {
            this.unsubscribe();
            this.subscribe(nextObservable);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.unsubscribe();
        }
      }, {
        key: "render",
        value: function render() {
          environment.warnOnce('observe()', 'observe() is deprecated. If you are using it with @aragon/api, using @aragon/api-react is now recommended instead.');
          var props = Object.assign({}, this.props); // Don't pass down the given observable

          delete props.observable;
          return /*#__PURE__*/React__default["default"].createElement(Component, _extends._extends({}, this.state, props));
        }
      }]);

      return _class;
    }(React__default["default"].Component), defineProperty._defineProperty(_class, "displayName", "Observe(".concat(getDisplayName._default(Component), ")")), defineProperty._defineProperty(_class, "propTypes", {
      observable: function observable(_ref2, _, componentName) {
        var observable = _ref2.observable;

        if (observable && typeof observable.subscribe !== 'function') {
          throw new Error("Invalid prop `observable` supplied to `".concat(componentName, "` ") + '(wrapped by `observe()`). ' + '`observable` must be an RxJS Observable-like object. ' + "Given ".concat(observable, " instead."));
        }
      }
    }), _class;
  };
};

var observe$1 = observe;
exports.observe = observe$1;